// store.ts
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import notificationReducer from './notificactionSlice'; // Import the new reducer
import clientConfigurationReducer from './clientConfigSlice'; // Import the new reducer
import alertReducer from './alertSlice';
import clientCompanyTypesReducer from './clientCompanyTypesSlice';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const rootReducer = combineReducers({
  auth: authReducer,
  alert: alertReducer,
  notification: notificationReducer,
  clientConfiguration: clientConfigurationReducer,
  clientCompanyTypes: clientCompanyTypesReducer,
});

const persistConfig = {
  key: 'root',
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export const persistor = persistStore(store);

// De-comment this line to log the state of the persistor
// persistor.subscribe(() => {
//   const state = persistor.getState();
//   console.log('[Persistor] State:', state);
//   // Puedes detectar si ya se rehidrató por ejemplo
// });
